import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import store from './store/index';
import routes from './routes';

import {api} from "./config";

const router = new VueRouter({
  mode: 'history',
  root:  '/apps',
  routes
});

router.beforeEach(async (to, from, next) => {
  // just logged in: localStorage has token, but state does not have auth user
  if (to.meta.requiresAuth) {
    let authUser = store.getters.getAuthUser;
    let isAuth = (authUser !== null && authUser.email_verified_at) ? true : false;
    if (!isAuth) {
      axios.get('/sanctum/csrf-cookie').then(() => {
        axios.get(api.currentUser)
        .then((resp) => {
            store.dispatch('setAuthUser', resp.data)
            authUser = resp.data;

            // 利用中ユーザーでなければregisterに
            if(authUser.active_at) {
              return next();
            } else {
              if(to.name != 'apps.expired' && to.name != 'apps.purchase' && to.name != 'apps.trial') {
                if('expired_at' in authUser && authUser.expired_at) {
                  let nowDate = new Date();
                  let expredAt = new Date(authUser.expired_at);
                  if(nowDate.getTime() > expredAt.getTime()) {
                    return next({name: 'apps.expired'});
                  }
                }
                if(authUser.email_verified_at) {
                  return next();
                } else {
                  window.location.href = '/signup/verify';
                }

              } else {
                return next();
              }
            }

        }).catch(err => {
            store.dispatch('unsetAuthUser')
            if(to.name != 'login' && /^\/apps/.test(to.path)) {
              return next({name: 'login'});
            } else {
              return next();
            }
        });
      });

    } else {
      if(authUser.active_at) {
        return next();
      } else {
        if(to.name != 'apps.expired' && to.name != 'apps.purchase' && to.name != 'apps.trial') {
          if('expired_at' in authUser && authUser.expired_at) {
            let nowDate = new Date();
            let expredAt = new Date(authUser.expired_at);
            if(nowDate.getTime() > expredAt.getTime()) {
              return next({name: 'apps.expired'});
            }
          }
          if(authUser.email_verified_at) {
            return next();
          } else {
            window.location.href = '/signup/verify';
          }

        } else {
          return next();
        }
      }
    }

  } else {
    return next();
  }

});

export default router;
